import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getFranceDepartmentsList() {
  return restApiClient
    .url(constructApiUrl(API.countries.getFranceDepartments.url, null))
    .get<string[]>()
}
